
import React from 'react';
import { Card, CardHeader, CardContent, CardTitle } from '@/components/ui/card';
import { Zap } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface UsageInsight {
  title: string;
  description: string;
  percentage: number;
}

interface UsageInsightCardProps {
  insights: UsageInsight[];
}

const UsageInsightCard: React.FC<UsageInsightCardProps> = ({ insights }) => {
  return (
    <Card className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-sm">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-xl font-bold text-gray-900 dark:text-white">Energy Usage Insights</CardTitle>
        <Zap className="h-4 w-4 text-energy-blue dark:text-energy-lightBlue" />
      </CardHeader>
      <CardContent>
        <div className="space-y-4 max-h-[420px] overflow-y-auto">
          {insights.map((insight, index) => (
            <div key={index} className="border-b border-gray-200 dark:border-gray-700 pb-4 last:border-0 last:pb-0">
              <h4 className="text-sm font-medium text-gray-800 dark:text-gray-200 mb-1">{insight.title}</h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">{insight.description}</p>
              <div className="mt-2 flex items-center">
                <div className="flex-1 bg-gray-200 dark:bg-gray-700 h-2 rounded-full overflow-hidden">
                  <div 
                    className="bg-energy-blue dark:bg-energy-lightBlue h-full rounded-full" 
                    style={{ width: `${insight.percentage}%` }}
                  ></div>
                </div>
                <span className="ml-2 text-xs font-medium text-gray-700 dark:text-gray-300">{insight.percentage}%</span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default UsageInsightCard;
